import { buildClassMap } from '../utilities/buildClassMap';
import { IFontStyles } from '../interfaces/IFontStyles';
import { DefaultFontStyles } from '../styles/DefaultFontStyles';

/**
 * {@docCategory FontClassNames}
 */
export const FontClassNames: { [key in keyof IFontStyles]?: string } = buildClassMap(DefaultFontStyles);



// WEBPACK FOOTER //
// ../src/classNames/FontClassNames.ts